import { Box, Code, Flex, Link } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTooltip } from 'components/common/tooltip';
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import {
  LOCAL_DATETIME_FORMAT,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMachineUser } from 'lib_ts/interfaces/i-machine-summary';
import { MouseEvent, useMemo } from 'react';
import { getShortenedSession } from 'services/session-events.service';

/** provide callback to do something when username is clicked, otherwise open a mailto link as the default behaviour */
export const MachineUser = (props: {
  user: IMachineUser;
  callback?: (m: IMachineUser, e: MouseEvent) => void;
}) => {
  const safeDisplayDate = useMemo(() => {
    try {
      return format(parseISO(props.user.connectDate), LOCAL_DATETIME_FORMAT, {
        timeZone: LOCAL_TIMEZONE,
      });
    } catch (e) {
      console.error(e);
      return '--';
    }
  }, [props.user.connectDate]);

  const shortSession = useMemo(() => {
    return getShortenedSession(props.user.session);
  }, [props.user.session]);

  return (
    <ErrorBoundary identifier="MachineUser">
      <CommonTooltip
        trigger={
          <Link
            onClick={(e) => props.callback?.(props.user, e)}
            href={props.callback ? undefined : `mailto:${props.user.email}`}
            className="cursor-pointer text-ellipsis "
          >
            {props.user.email}
          </Link>
        }
        content={
          <Flex direction="column" gap={RADIX.FLEX.GAP.SM}>
            <Box>
              Session: <Code>{shortSession}</Code>
            </Box>
            <Box>Connected: {safeDisplayDate}</Box>
          </Flex>
        }
      />
    </ErrorBoundary>
  );
};
